const fragmentLinkSchema = {
	attrs: { id: { default: null } },
};

export default fragmentLinkSchema;
